{
  "info": "Informazioni",
  "negative": "Errore",
  "notice": "Avvertenza",
  "positive": "Operazione riuscita"
}
